import initJobDetails from '~/jobs/job_details_bundle';

document.addEventListener('DOMContentLoaded', initJobDetails);



// WEBPACK FOOTER //
// ./pages/projects/jobs/show/index.js